const e = "_textContainer_djsje_1", t = "_is2Liner_djsje_6", n = "_content_djsje_10", s = "_freeText_djsje_18", o = "_icon_djsje_25", _ = {
  textContainer: e,
  is2Liner: t,
  content: n,
  freeText: s,
  icon: o
};
export {
  n as content,
  _ as default,
  s as freeText,
  o as icon,
  t as is2Liner,
  e as textContainer
};
//# sourceMappingURL=index.es570.js.map
